import { Routes, Route } from "react-router-dom";
import Login from "./Login";
import Home from "./Home";
import Signup from "./Signup";
import ResetPassword from "./ResetPassword";
import NoPage from "./NoPage";

import Products from "./office/Products";
import Quotes from "./office/Quotes";
import Profile from "./office/Profile";
import Office from "./office/Dashboard";
import SaleApp from "./office/SaleApp";
import LocApp from "./office/LocApp";
import Customers from "./office/Customers";
import Expen from "./office/Expen";
import Report from "./office/Reports";
import Logout from "./office/Logout";
import Pdf from "./office/Pdf";
import Lead from "./office/Lead";

export default function Pagerouting() {
  return (
    <>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="sign-up" element={<Signup />} />
        <Route path="office" element={<Office />} />
        <Route path="quotes" element={<Quotes />} />
        <Route path="lead" element={<Lead />} />
        <Route path="customers" element={<Customers />} />
        <Route path="reports" element={<Report />} />
        <Route path="expen" element={<Expen />} />
        <Route path="LocApp" element={<LocApp />} />
        <Route path="SaleApp" element={<SaleApp />} />
        <Route path="pdf" element={<Pdf />} />
        <Route path="products" element={<Products />} />
        <Route path="logout" element={<Logout />} />
        <Route path="profile" element={<Profile />} />
        <Route index element={<Home />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </>
  );
}
